import axios from "axios";
import { forgetDisclaimerAcknowledgements } from "./disclaimerGate";

// Fail fast on a missing/placeholder backend URL (audit-20260609-006).
// If build-env injection fails, a production bundle must fail loudly at
// boot instead of silently issuing every request against `undefined/api`.
let BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").trim();

if (!BACKEND_URL || /^SET_IN_/.test(BACKEND_URL)) {
  const message =
    "REACT_APP_BACKEND_URL is unset or still a placeholder sentinel. Set it in the build environment (Amplify build env for deployed builds; copy .env.example to .env for local dev).";
  if (process.env.NODE_ENV === "production") {
    throw new Error(message);
  }
  console.error(message);
  BACKEND_URL = "http://localhost:8001";
}

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      // STARSEED-CAPMARKETS-257 — a session that ends here ends the
      // disclaimer gate's per-member flags with it (same-tab re-login).
      forgetDisclaimerAcknowledgements();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;

// Utility functions
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount || 0);
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatPercent = (value) => {
  return `${value >= 0 ? "+" : ""}${value.toFixed(2)}%`;
};
